<template>
  <base-modal :visible="visible" @update:visible="close">
    <div class="card-content">
      <div class="product-info">
        <van-image class="image" :src="goodsInfo.mobileBanner" />
        <div class="info-info">
          <p class="product-name el2">{{goodsInfo.name}}</p>
          <p class="el2">{{goodsInfo.applyTo}}</p>
        </div>
      </div>
    </div>
    <p class="tips" v-show="timeIntervalList.length">*所有时段选择均为船上时间，请根据船上提示调整您的时区避免错过活动</p>
    <div :class="['card-content', {'padding-bottom': !goodsInfo.needSync}]" style="padding-top:0">
      <!-- 预订时间段 -->
      <date-picker
        v-for="(item, index) in timeIntervalList"
        :ref="`refDatePicker${index}`"
        :key="item.timeslot"
        :initData="{...item, index}"
        :initChoosed="timeIntervalSelected[index]"
        @stockChange="stockChange" />
      <div class="field-title">数量</div>
      <div class="number-box">
        <van-stepper v-model="goodsNumber" input-width="50" :min="goodsNumberMin" :disabled="goodsNumberDisabled" />
        <span class="stock">剩余：{{stock}}</span>
        <div class="sell-out">
          <sell-out-tip v-if="goodsInfo.showLowStock == true || goodsInfo.outOfStock == true" :showLowStock="goodsInfo.showLowStock" :outOfStock="goodsInfo.outOfStock" size="24"/>
        </div>
      </div>
      <!-- 选择乘客 -->
      <choose-customer
        ref="chooseCustomer"
        v-show="goodsInfo.needSync"
        :goodsInfo="goodsInfo"
        :isFullCabinBooking="isFullCabinBooking"
        :canBookingGuests="canBookingGuests"
        :isShoppingCart="isShoppingCart"
        @customerChange="customerChange"
        @customerSubmit="customerSubmit"
      />
      <coupon-select-popup :view-type="viewTypeCoupon"
                           :product-id="goodsInfo.id"
                           :user-coupon="userCoupon"
                           :goods-number="goodsNumber"
                           :refresh="refreshCoupon"
                           :shopping-cart-ids="goodsInfo?.shoppingCartIds || []"
                           @refreshCouponEnd="refreshCouponEnd" @couponChange="couponChange" />
      <template v-if="goodsInfo.productGift">
        <div class="product-gift-box not-margin">
          <div class="icon">
            <img src="../assets/icons/iconGift.png" alt="" />
          </div>
          <div class="name">{{goodsInfo.productGift.productGiftName}}</div>
        </div>
        <template v-if="hasTimeslotChoice">
          <div class="product-gift-time-box isFlex">
            <div class="title">礼品预订时间段：</div>
            <div class="content">
              <div class="product-gift-select-box" @click="showShipDatePicker=true">
                <div class="select-title el">{{shipDateView}}</div>
                <i class="select-icon van-icon van-icon-arrow-down"></i>
              </div>
              <van-popup v-model="showShipDatePicker" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="shipDateList"
                    @cancel="showShipDatePicker = false"
                    @confirm="shipDatePickerConfirm"
                />
              </van-popup>
              <van-popup v-model="showShipDatePicker"
                         round
                         position="bottom"
                         get-container="body">
                <van-picker v-if="showShipDatePicker"
                            title="请选择日期"
                            :default-index="shipDateDefaultIndex"
                            show-toolbar
                            value-key="label"
                            :columns="shipDateList"
                            @cancel="showShipDatePicker=false"
                            @confirm="shipDatePickerConfirm"></van-picker>
              </van-popup>
              <div class="product-gift-select-box" @click="showTimeslotPicker=true">
                <div class="select-title el">{{timeslotView}}</div>
                <i class="select-icon van-icon van-icon-arrow-down"></i>
              </div>
              <van-popup v-model="showTimeslotPicker"
                         round
                         position="bottom"
                         get-container="body">
                <van-picker v-if="showTimeslotPicker"
                            title="请选择时间段"
                            :default-index="timeslotDefaultIndex"
                            show-toolbar
                            value-key="label"
                            :columns="timeslotList"
                            @cancel="showTimeslotPicker=false"
                            @confirm="timeslotPickerConfirm"></van-picker>
              </van-popup>
            </div>
          </div>
          <div class="product-gift-surplus-box el">剩余:{{timeslotCurrentInv}}</div>
        </template>
        <div v-else class="product-gift-surplus-box is-alone">
          <span v-if="timeslotCurrentInv<=0" class="is-empty">当前礼品已赠完</span>剩余：{{timeslotCurrentInv}}
        </div>
        <div class="product-gift-desc-box is-margin-top">
          *&nbsp;部分赠送的产品对乘客参与或使用有一定的限制条件（如年龄、身高、身体状况等）；不符合条件的乘客将无法参与预订赠礼活动或无法使用所赠产品，预订前请务必仔细阅读相关产品详情页面。
        </div>
      </template>
    </div>
    <div class="btn-box">
      <div class="btn-item" @click="close">取消</div>
      <div class="btn-item btn-booking" @click="handleSubmit">确认</div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import BookingDatePicker from './dialog_booking/BookingDatePicker'
import BookingChooseCustomer from './dialog_booking/BookingChooseCustomer'
import CouponSelectPopup from '@/components/coupon/CouponSelectPopup.vue'
import api from '@/api'
import { showLoading, hideLoading, showAlert, showToast } from '@/utils/tools'
import dayjs from 'dayjs'
import uniq from 'lodash/uniq'
import { getShoppingCartNum, bindGioTrack } from '@/plugins/common'
import SellOutTip from '@/components/SellOutTip.vue'

import { Toast } from 'vant';

export default {
  name: 'DialogBooking',

  props: {
    visible: Boolean,
    goodsInfo: Object,
    // DIALOG_BOOKING:加入购物车弹窗 | CART_LIST:购物车页(预览+编辑) | CART_LIST_DIALOG:购物车弹窗(预览+编辑) | PREVIEW:预览
    viewTypeCoupon: {
      type: String,
      default: function () {
        return "DIALOG_BOOKING"
      }
    },
    isShoppingCart: Boolean
  },

  components: {
    BaseModal,
    'date-picker': BookingDatePicker,
    'choose-customer': BookingChooseCustomer,
    SellOutTip,
    CouponSelectPopup
  },

  data () {
    return {
      goodsNumber: 1,
      goodsNumberMin: 1,
      goodsNumberDisabled: false,
      stock: 0,
      timeIntervalList: [],
      timeIntervalSelected: [],
      isPackageProduct: false,
      isFullCabinBooking: false,
      canBookingGuests: [],
      productGiftGuestPersons: [],
      showShipDatePicker: false,
      shipDateDefaultIndex: 0,
      shipDateList: [],
      shipDateView: null,
      shipDateValue: null,
      showTimeslotPicker: false,
      timeslotDefaultIndex: 0,
      timeslotList: [],
      timeslotView: null,
      timeslotValue: null,
      timeslotCurrentInv: -1,
      hasTimeslotChoice: false,
      userCoupon: null,
      refreshCoupon: false
    }
  },

  watch: {
   async visible (newVal) {
    console.log(this.goodsInfo,'this.goodsInfothis.goodsInfo')
      this.goodsNumber = this.goodsInfo && this.goodsInfo.needSync ? 0 : 1
      this.goodsNumberMin = this.goodsInfo && this.goodsInfo.needSync ? 0 : 1
      this.goodsNumberDisabled = this.goodsInfo && this.goodsInfo.needSync
      this.stock = 0
      this.timeIntervalList = []
      this.timeIntervalSelected = []
      this.productGiftGuestPersons = []
      this.showShipDatePicker = false
      this.shipDateDefaultIndex = 0
      this.shipDateList = []
      this.shipDateView = null
      this.shipDateValue = null
      this.showTimeslotPicker = false
      this.timeslotDefaultIndex = 0
      this.timeslotList = []
      this.timeslotView = null
      this.timeslotValue = null
      this.timeslotCurrentInv = -1
      this.hasTimeslotChoice = false
      // this.userCouponId = null;
      this.userCoupon = this.goodsInfo && this.goodsInfo.userCoupon?.couponUserId > 0 ? this.goodsInfo.userCoupon : null;
      // if (newVal && this.goodsInfo.id && this.$store.state.bindTicket) this.getPackageProducts()
      if (newVal && this.goodsInfo.id && this.$store.state.bindTicket) {
        this.canBookingGuests=[]
        this.getCanBookingGuests()
        if (this.goodsInfo.initBookingGuests?.length>1) {
         this.getOtherCanBookingGuests()
        }
      }
     
    }
  },

  computed: {
    isEdit () {
      return Boolean(this.goodsInfo.shoppingCartIds)
    }
  },

  methods: {
    async handleSubmit () {
      const { customerChoosed, customerList } = this.$refs.chooseCustomer
      const { needSync, id, shoppingCartIds } = this.goodsInfo
      console.log(this.goodsInfo)
      if (needSync && !customerChoosed.length) return showToast('请选择乘客')

      if (this.isPackageProduct && this.checkPackageTimeSlotRepeat()) return showToast('您的活动时间有冲突，请重新选择')
      const customerChoosedFormat = [].concat.apply([], customerList.map(x => x.bookingGuests)).filter(x => customerChoosed.indexOf(x.id) >= 0)
          // 检查  needSync  !this.isPackageProduct 是否有儿童乘客菜单未选择
      if (needSync && !this.isPackageProduct) {
        const targetCustomer = customerChoosedFormat.find(customer => {
          return  customer.products?.length===2  &&!customer.selectedProductId
        })
        if (targetCustomer) {
          return Toast({
            message:`请确认选择标准菜单或儿童菜单`,
            position: 'bottom',
            className: 'no-wrap-toast',
          })
        }
      }
      let addProductItems = []
      if (needSync) {
        if (this.isPackageProduct) {
          for (let i = 0; i < this.timeIntervalSelected.length; i++) {
            const { productId, shipDate = '', timeslot = -1 } = this.timeIntervalSelected[i]
            addProductItems = addProductItems.concat(customerChoosedFormat.map(x => ({
              bookingRecordId: x.bookingRecord_Id || x.bookingRecordId,
              number: 1,
              guestRecordId: x.id,
              shipDate,
              timeslot,
              productId,
              itemType: 0
            })))
          }
        } else {
          addProductItems = customerChoosedFormat.map(x => ({
            bookingRecordId: x.bookingRecord_Id || x.bookingRecordId,
            number: 1,
            guestRecordId: x.id,
            shipDate: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].shipDate : '',
            timeslot: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].timeslot : -1,
            productId: x.selectedProductId||id, // 默认主产品id
            itemType: 0
          }))
        }
      } else {
        for(let i = 0; i < this.goodsNumber; i++) {
          addProductItems = addProductItems.concat({
            bookingRecordId: 0,
            number: 1,
            guestRecordId: 0,
            shipDate: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].shipDate : '',
            timeslot: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].timeslot : -1,
            productId: id,
            itemType: 0
          })
        }
        console.log(addProductItems)
        // addProductItems = addProductItems.concat({
        //   bookingRecordId: 0,
        //   number: this.goodsNumber,
        //   guestRecordId: 0,
        //   shipDate: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].shipDate : '',
        //   timeslot: this.timeIntervalSelected.length ? this.timeIntervalSelected[0].timeslot : -1,
        //   productId: id,
        //   itemType: 0
        // })
      }
      showLoading('提交中...')
      const params = {
        productId: id,
        number: this.goodsNumber,
        addProductItems,
        couponId: this.userCoupon?.couponUserId || 0
      }
      if(this.goodsInfo.productGift) {
        this.productGiftGuestPersons && this.productGiftGuestPersons.forEach((item) => {
          let isExist = addProductItems.find(r=> r.bookingRecordId === item.BookingRecordId && r.guestRecordId === item.Id);
          if(isExist) {
            addProductItems.push({
              bookingRecordId: item.BookingRecordId,
              number: 1,
              guestRecordId: item.Id,
              shipDate: this.shipDateValue.value || null,
              timeslot: this.timeslotValue.value || null,
              productId: this.shipDateValue.productId || this.goodsInfo.productGift.productGiftId,
              itemType: 6
            })
          }
        })
      }

      showLoading('提交中...')
      const { errCode, errMsg } = this.isEdit ? await api.editProduct({
        shoppingCartIds,
        addProduct: params
      }) : await api.addProduct({
        ...params,
        couponId: this.userCoupon?.couponUserId || 0
      })
      if (errCode === 0) await getShoppingCartNum()
      hideLoading()
      if (errCode === 0) {
        showToast.success(this.isEdit ? '修改成功' : '添加成功')
        this.$emit('submitSuccess')
        this.close()
        bindGioTrack({
          productName: this.goodsInfo.name,
          productCategory: this.goodsInfo.categoryName || '',
          productId: id
        })
      } else {
        showAlert(errMsg || '提交失败，请稍后重试')
      }
    },
    checkPackageTimeSlotRepeat () {
      if (this.timeIntervalList.length === 1) return false
      const shipDateChoosedAll = this.timeIntervalList.map((x, i) => {
        const { shipDateChoosed, shipDateColumns } = this.$refs[`refDatePicker${i}`][0]
        return shipDateColumns[shipDateChoosed]
      })
      const shipDateRepeat = uniq(shipDateChoosedAll.filter(x => shipDateChoosedAll.filter(j => j === x).length > 1))
      if (!shipDateRepeat.length) return false
      let repeatAll = []
      shipDateRepeat.forEach(shipDateItem => {
        const choosedAll = []
        this.timeIntervalList.forEach((x, i) => {
          const { shipDateChoosed, shipDateColumns, timeSlotChoosed, timeSlotColumns } = this.$refs[`refDatePicker${i}`][0]
          const [start, end] = timeSlotColumns[timeSlotChoosed].split('-')
          const startSplit = start.split(':')
          const endSplit = end.split(':')
          if (shipDateItem === shipDateColumns[shipDateChoosed]) choosedAll.push([Number(`${startSplit[0]}${startSplit[1]}`), Number(`${endSplit[0]}${endSplit[1]}`)])
        })
        const timeSlotRepeat = choosedAll.filter((x, i) => choosedAll.filter((y, j) => i !== j && !(y[1] < x[0] || x[1] < y[0])).length)
        repeatAll = repeatAll.concat(timeSlotRepeat)
      })
      return Boolean(repeatAll.length)
    },
    customerChange(num) {
      this.goodsNumber = num
      this.refreshCoupon = true
      console.log(num)
    },
    // 新增舱房提交
    customerSubmit(val) {
      this.getCanSelectGuestsByProductGift(val);
    },
    stockChange ({ index, stock, shipDate, timeslot }) {
      this.timeIntervalSelected[index].shipDate = shipDate
      this.timeIntervalSelected[index].timeslot = timeslot
      this.stock = stock
    },
    async getPackageProducts () {
      showLoading()
      const { errCode, errMsg, data } = await api.getPackageProducts({
        productId: this.goodsInfo.id,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD')
      })
      hideLoading()
      if (errCode === 0) {
        const { normalProductInvs, packageProductItemInvs, currentInv } = data
        this.isPackageProduct = Boolean(packageProductItemInvs && packageProductItemInvs.length)
        // 产品数量初始化
        if (this.goodsInfo.initBookingGuestsChoosed && this.goodsInfo.initBookingGuestsChoosed.length) {
          this.goodsNumber = this.goodsInfo.initBookingGuestsChoosed.length
        } else if (this.isFullCabinBooking) {
          // this.goodsNumber = this.$store.state.bindTicket.bookingGuests.length
        } else {
          this.goodsNumber = this.goodsInfo.qty || (this.goodsInfo.needSync ? 0 : 1)
        }
        // 普通产品
        if (normalProductInvs && normalProductInvs.length) {
          if (normalProductInvs.length === 1 && normalProductInvs[0].shipDate === '1753-01-01') {
            this.stock = normalProductInvs[0].currentInv
          } else {
            const shipDates = uniq(normalProductInvs.map(x => x.shipDate))
            const timeIntervalList = [{
              title: '预订时间段',
              shipDates: shipDates.map(x => ({
                shipDate: x,
                timeSlotList: normalProductInvs.filter(j => j.shipDate === x)
              }))
            }]
            const { currentInv, shipDate, timeslot } = timeIntervalList[0].shipDates[0].timeSlotList[0]
            this.stock = currentInv
            this.timeIntervalSelected = [this.goodsInfo.shipDate && this.goodsInfo.timeSlot ? {
              shipDate: this.goodsInfo.shipDate,
              timeslot: this.goodsInfo.timeSlot
            } : {
              shipDate,
              timeslot
            }]
            this.timeIntervalList = timeIntervalList
          }
        }
        // 打包产品
        if (packageProductItemInvs && packageProductItemInvs.length) {
          const timeIntervalList = []
          const timeIntervalSelected = []
          this.stock = currentInv
          for (let i = 0; i < packageProductItemInvs.length; i++) {
            const packageInvViews = packageProductItemInvs[i].packageInvViews
            const shipDates = uniq(packageInvViews.map(x => x.shipDate))
            timeIntervalList.push({
              title: packageProductItemInvs[i].productName,
              noTimeslot: shipDates[0] === '1753-01-01',
              shipDates: shipDates.map(x => ({
                shipDate: x,
                timeSlotList: packageInvViews.filter(j => j.shipDate === x)
              }))
            })
            timeIntervalSelected.push({
              productId: packageProductItemInvs[i].productId,
              shipDate: packageInvViews[0].shipDate,
              timeslot: packageInvViews[0].timeslot
            })
          }
          this.timeIntervalList = timeIntervalList
          this.timeIntervalSelected = this.goodsInfo.packageItems ? this.goodsInfo.packageItems.map(x => ({
            productId: x.productId,
            shipDate: x.shipDate,
            timeslot: x.timeSlot
          })) : timeIntervalSelected
        }
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    async getCanBookingGuests() {
      showLoading()
      const { errCode, errMsg, data } = await api.getCanBookingGuests({
        productId: this.goodsInfo.id,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD'),
        bookingId: this.$store.state.bindTicket.bookingId
      })
      hideLoading()
      if (errCode === 0) {
        this.isFullCabinBooking = data.isFullCabinBooking;
        this.canBookingGuests = this.canBookingGuests.concat(data.bookingGuests) ;
        await this.getPackageProducts();
        this.refreshCoupon = true;
        if(this.goodsInfo.productGift) {
          await this.getProductGiftList();
        }
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
    // 获取购物车中绑定的其他仓房订单
    async getOtherCanBookingGuests() {
      const bookingIds = this.goodsInfo.initBookingGuests
        .filter(item => item.bookingId !== this.$store.state.bindTicket.bookingId)
        .map(item => item.bookingId);

      if (!bookingIds.length) return;

      showLoading();

      try {
        const requests = bookingIds.map(id =>
          this.fetchCanBookingGuests(id).catch(error => {
            console.error(`请求失败(${id}):`, error);
          })
        );
        await Promise.all(requests);
      } finally {
        hideLoading();
      }
    },
    async fetchCanBookingGuests(bookingId) {
      const { errCode, errMsg, data } = await api.getCanBookingGuests({
        productId: this.goodsInfo.id,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD'),
        bookingId: bookingId
      })
      if (errCode === 0) {
        this.canBookingGuests = this.canBookingGuests.concat(data?.bookingGuests || []);
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    },
     

    close () {
      this.$emit('update:visible', false)
    },
    // 获取赠品日期列表
    async getProductGiftList(bookingId = null) {
      console.log('getProductGiftList')
      showLoading()
      const { isSuccess, ErrMsg, data } = await api.getProductGiftList({
        productId: this.goodsInfo.id,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD')
      })
      hideLoading()
      if (isSuccess) {
        const { ProductGiftInvItems } = data;

        if(bookingId) {
          await this.getCanSelectGuestsByProductGift(bookingId);
        } else {
          await this.getCanSelectGuestsByProductGift();
        }

        console.log(ProductGiftInvItems)
        // 赠品日期列表
        if (ProductGiftInvItems && ProductGiftInvItems.length) {
          //是否可以选择时间段判断
          let hasTimeslotChoice = ProductGiftInvItems.filter(x => x.ShipDate !== '1753-01-01').length > 0;
          console.log(hasTimeslotChoice);
          this.hasTimeslotChoice = hasTimeslotChoice;
          if(!hasTimeslotChoice) {
            //不用选择时间段，获取库存数量
            this.timeslotCurrentInv = ProductGiftInvItems[0].CurrentInv
            this.shipDateValue = {
              label: ProductGiftInvItems[0].ShipDate,
              value: ProductGiftInvItems[0].ShipDate,
              productId: ProductGiftInvItems[0].ProductId
            }
            this.timeslotValue = {
              label: "",
              value: ProductGiftInvItems[0].Timeslot,
              currentInv: ProductGiftInvItems[0].CurrentInv
            }
            return
          }

          let shipDateList = []
          ProductGiftInvItems.forEach((item)=> {
            shipDateList.push({
              label: item.ShipDate,
              value: item.ShipDate,
              productId: item.ProductId
            })
          })
          console.log(shipDateList)
          if(shipDateList.length) {
            shipDateList = shipDateList.filter((item, index, arr) => {
              return arr.findIndex(x => x.value === item.value) === index;
            })
            this.shipDateList = shipDateList;
            this.shipDateDefaultIndex = 0;
            this.shipDateView = shipDateList[this.shipDateDefaultIndex].label;
            this.shipDateValue = shipDateList[this.shipDateDefaultIndex];
            console.log(this.shipDateValue);
            await this.getProductGiftTimeSlotList(shipDateList[this.shipDateDefaultIndex].productId, this.shipDateValue.value)
          }
        } else {
          //没有库存
          this.timeslotCurrentInv = 0;
          this.shipDateValue = {
            label: null,
            value: null,
            productId: null
          }
          this.timeslotValue = {
            label: null,
            value: null
          }
        }
      } else {
        showAlert(ErrMsg || '页面数据获取失败，请稍后重试')
      }
    },
    // 根据选中的日期获取时间段
    async getProductGiftTimeSlotList (productId, shipDate) {
      showLoading()
      const { isSuccess, ErrMsg, data } = await api.getProductGiftTimeSlotList({
        productId: productId,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD'),
        shipDate: shipDate
      })
      hideLoading()
      if (isSuccess) {
        // 赠品日期列表
        if (data && data.length) {
          let timeslotList = []
          data.forEach((item)=> {
            timeslotList.push({
              label: `${item.TimeSlotStart}-${item.TimeSlotEnd}`,
              value: item.TimeSlot,
              currentInv: item.CurrentInv
            })
          })
          console.log(timeslotList);
          if(timeslotList.length) {
            timeslotList = timeslotList.filter((item, index, arr) => {
              return arr.findIndex(x => x.value === item.value) === index;
            })
            this.timeslotList = timeslotList;
            this.timeslotDefaultIndex = 0;
            this.timeslotView = timeslotList[this.timeslotDefaultIndex].label;
            this.timeslotValue = timeslotList[this.timeslotDefaultIndex];
            this.timeslotCurrentInv = timeslotList[this.timeslotDefaultIndex].currentInv;
            console.log(this.timeslotValue)
          }
        }
      } else {
        showAlert(ErrMsg || '页面数据获取失败，请稍后重试')
      }
    },
    // 获取可选择赠品的乘客列表
    async getCanSelectGuestsByProductGift (bookingId = null) {
      showLoading();
      const { Success, ErrMsg, Data } = await api.getCanSelectGuestsByProductGift({
        productId: this.goodsInfo.id,
        bookingId: bookingId || this.$store.state.bindTicket.bookingId,
        sailDate: dayjs(this.$store.state.bindTicket.sailDate).format('YYYY-MM-DD'),
        shipCode: this.$store.state.bindTicket.shipCode
      })
      hideLoading()
      if (Success) {
        this.productGiftGuestPersons = this.productGiftGuestPersons.concat([...Data.GuestPersons]);
      } else {
        showAlert(ErrMsg || '页面数据获取失败，请稍后重试')
      }
    },
    // 切换日期-确认
    async shipDatePickerConfirm(val) {
      let { label, value, productId } = val;
      await this.getProductGiftTimeSlotList(productId, value)
      this.showShipDatePicker = false;
      this.shipDateDefaultIndex = this.shipDateList && this.shipDateList.findIndex(r => r.value === value)
      this.shipDateView = label;
      this.shipDateValue = {...val};
    },
    // 切换时间段
    timeslotPickerConfirm(val) {
      let {label, value, currentInv} = val;
      this.showTimeslotPicker = false;
      this.timeslotDefaultIndex = this.timeslotList && this.timeslotList.findIndex(r => r.value === value);
      this.timeslotView = label;
      this.timeslotValue = {...val};
      this.timeslotCurrentInv = currentInv;
    },
    couponChange(val) {
      const { coupon, checked } = val;
      this.userCoupon = {
        couponUserId: checked ? coupon.couponUserId : 0,
        couponTitle: checked ? coupon.couponTitle : ''
      };
    },
    refreshCouponEnd(val) {
      this.refreshCoupon = val;
    }
  }
}
</script>
<style lang="less" scoped>
.card-content {
  padding: 30px 30px 24px;
  &.padding-bottom {
    padding-bottom: 16px;
  }
  ::v-deep .field-title {
    margin-top: 28px;
    font-size: 24px;
    color: #000;
    line-height: 40px;
  }
}
.product-info {
  display: flex;
  .image {
    flex: none;
    width: 226px;
    margin-right: 28px;
  }
  .info-info {
    max-width: 3.3rem;
    font-size: 24px;
    color: #666;
    .product-name {
      font-size: 30px;
      color: #333;
      line-height: 52px;
    }
  }
}
.tips {
  margin-top: 30px;
  padding: 26px 30px;
  font-size: 18px;
  color: #333;
  line-height: 26px;
  background-color: #e8ecef;
}
.number-box {
  display: flex;
  align-items: center;
  height: 76px;
  .stock {
    margin-left: 30px;
    font-size: 24px;
    color: #999;
  }
}
.btn-box {
  display: flex;
  border-top: 1Px solid #eaeaea;
  font-size: 30px;
  color: #999;
  text-align: center;
  .btn-item {
    flex: none;
    width: 50%;
    line-height: 98px;
    &.btn-booking {
      .btn-linear-gradient;
      color: #333;
    }
  }
}

.sell-out{
  display: flex;
  justify-content: flex-end;
  margin-left: 20px;
  flex-shrink: 0;
}
</style>
